import { render, staticRenderFns } from "./RecipeItemAssociationCreate.vue?vue&type=template&id=92f6287c&"
import script from "./RecipeItemAssociationCreate.vue?vue&type=script&lang=js&"
export * from "./RecipeItemAssociationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports